module.exports = __webpack_public_path__ + "media/images/applicant/icon-ku-d3503eafd86961c8ffe0c76f0f4e2269.png";